<template>
    <div class="w-100 text-center">
        <h5 class="mt-3">Une erreur est survenue. Veuillez contacter l'établissement par téléphone.</h5>
    </div>
</template>